var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-list-v2',{attrs:{"listdata":_vm.levels,"menuactions":_vm.actions},on:{"partica-event":_vm.eventHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }